import { useState, useEffect, useRef } from 'react';

export default function useTimeout(delay, key) {
  const [, setTrack] = useState(0);
  const timeoutRef = useRef(null);
  const doneRef = useRef(null);
  const keyRef = useRef(key);

  if (keyRef.current !== key) {
    keyRef.current = key;
    doneRef.current = false;
  }

  useEffect(() => {
    timeoutRef.current = window.setTimeout(() => {
      doneRef.current = true;
      // force an update
      setTrack((t) => t + 1);
    }, delay);

    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [key, setTrack, delay]);

  return doneRef.current;
}
